import api from "./api";

const BASE = "/system/encryption-keys";

export const getActiveEncryptionKey = async () =>
    (await api.get(`${BASE}/active`)).data;

export const getEncryptionKeys = async () =>
    (await api.get(BASE)).data;

export const rotateEncryptionKey = async () =>
    (await api.post(`${BASE}/rotate`)).data;

export default {
    getActiveEncryptionKey,
    getEncryptionKeys,
    rotateEncryptionKey,
};